// import React from 'react';

import { createEditorPluginAIConfigItemMarkdown, isInitialContextSelectionRange } from '../../config-items/config-items';
import { rovoChatWithAgent } from '../../provider/prompt-requests/rovo-chat';
import { createInsertAtCurrentPosition, createInsertAtTop, createInsertBelow, createReplace } from '../config-item-actions/markdown';
import { sliceOrNodeToMarkdown } from '../../config-items/slice-or-node-to-markdown';
// import { AgentIcon } from '../assets/icons/agent-icon/AgentIcon';

export const createAgentConfigItem = (selectionType, agent) => {
  return createEditorPluginAIConfigItemMarkdown({
    title: () => agent.name,
    description: () => agent.description || 'No description',
    selectionType,
    agent,
    // icon: () => (
    //   <AgentIcon
    //     size="small"
    //     agent={{ name: agent.name, named_id: agent.namedId }}
    //   />
    // ),
    getInitialContext: ({
      editorView,
      positions,
      intl,
      updateIdMap
    }) => {
      const selection = sliceOrNodeToMarkdown({
        slice: editorView.state.doc.slice(positions[0], positions[1]),
        intl,
        editorView,
        convertTo: 'markdown-plus',
        updateIdMap,
        selectionType
      });
      const document = sliceOrNodeToMarkdown({
        node: editorView.state.doc,
        intl,
        editorView,
        convertTo: 'markdown-plus',
        updateIdMap,
        selectionType
      });
      return {
        selection: selection.markdown,
        document: document.markdown,
        userLocale: intl.locale,
        intentSchemaId: 'DISABLED'
      };
    },
    triggerPromptRequest({
      initialContext,
      editorSchema,
      promptInput,
      promptInputADF
    }) {
      return rovoChatWithAgent({
        agent,
        customPrompt: promptInput || '',
        customPromptADF: promptInputADF ? JSON.parse(promptInputADF) : undefined,
        fullDocument: initialContext.document,
        currentSelection: isInitialContextSelectionRange(initialContext) ? initialContext.selection : ''
      });
    },
    promptLabel: () => agent.name,
    promptHint: () => 'Tell the Agent to write anything or choose from below',
    // promptConversationStarters: (kickoffAiExperience, updateTextInput, updateADFInput) => input => {
    //     if (input.length > 0) {
    //       return [];
    //     }

    //     return (agent.conversation_starters || []).map((cs, idx) => ({
    //       label: cs,
    //       value: `conversation-starter-${idx}`,
    //       onSelect: () => {
    //         const csAdf = JSON.stringify({
    //           version: 1,
    //           type: 'doc',
    //           content: [
    //             {
    //               type: 'paragraph',
    //               content: [
    //                 {
    //                   type: 'text',
    //                   text: cs,
    //                 },
    //               ],
    //             },
    //           ],
    //         });

    //         updateTextInput(cs);
    //         updateADFInput(csAdf);
    //         kickoffAiExperience({
    //           configItem,
    //           userInput: cs,
    //           userADFInput: csAdf,
    //         });
    //       },
    //       onSuggestionFocused: () => { },
    //     }));
    //   },
    isVisible: () => true,
    getBackendModel: () => 'assistance-service',
    statusLozengeType: 'beta',
    disableInterrogation: () => true,
    actions: selectionType === 'empty' ? [createInsertAtTop({
      appearance: 'secondary'
    }), createInsertAtCurrentPosition({
      appearance: 'primary'
    })] : [createReplace({
      appearance: 'primary'
    }), createInsertBelow({
      appearance: 'secondary'
    })]
  });
};